import { render } from "./ResponseCreateModal.vue?vue&type=template&id=5f268658&scoped=true"
import script from "./ResponseCreateModal.vue?vue&type=script&lang=js"
export * from "./ResponseCreateModal.vue?vue&type=script&lang=js"

import "./ResponseCreateModal.vue?vue&type=style&index=0&id=5f268658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f268658"]])

export default __exports__